import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import Logo from "../shared/Logo";
import { getSymbolImageUrl } from "../../lib/symbolImage";

interface ScreenerLogoProps {
  symbol: string;
  /** Gives the fallback tile its initial, as on the ticker page. */
  name?: string;
  size?: number;
}

/**
 * A company logo set on a grey rounded tile, as the AI analysis report shows
 * it (Ben, 2026-09-28), so logos with and without their own background read
 * as one set. A company without a logo gets the app's initial tile, the
 * shared Logo's fallback that the ticker page uses.
 */
export const ScreenerLogo = ({ symbol, name, size = 36 }: ScreenerLogoProps) => {
  const theme = useTheme();
  const src = getSymbolImageUrl(symbol);
  const [failedSrc, setFailedSrc] = useState<string>();
  return (
    <Box sx={{ display: "flex", flex: "none" }}>
      {failedSrc === src && (
        <Logo src={undefined} alt="" ticker={symbol} companyName={name} size={size} />
      )}
      {failedSrc !== src && (
        <Box
          sx={{
            display: "flex",
            width: size,
            height: size,
            p: `${Math.round(size * 0.17)}px`,
            borderRadius: "8px",
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(0, 0, 0, 0.045)",
          }}
        >
          <Box
            component="img"
            src={src}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setFailedSrc(src)}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "3px",
            }}
          />
        </Box>
      )}
    </Box>
  );
};
